// extracted by mini-css-extract-plugin
export default {"scroll":"Result_scroll__mhfX7","result":"Result_result__qWZTs"};